import { Injectable } from '@angular/core';

import { OfferSource } from '@cds';
import { Fixture } from '@cds/betting-offer';
import { FixtureFactory } from '@frontend/sports/betting-offer/feature/fixture-factories';
import { PickSourceProvider } from 'packages/sports/web/app/src/option-pick/pick-source.provider';

import { PickAddPayload } from '../../core/external-betslip-actions';
import { PickId, V1PickId, V2OptionMarketPickId } from '../../core/picks/pick-id';

@Injectable()
export class BetslipWebBridgeService {
    constructor(
        private eventService: FixtureFactory,
        private pickSourceProvider: PickSourceProvider,
    ) {}

    getAddPickPayload(fixture: Fixture, optionId: number): PickAddPayload | null {
        const event = this.eventService.create(fixture);

        for (const optionGroup of event.optionGroups) {
            const option = optionGroup.options.find((current) => current.id === optionId);

            if (option) {
                const pickSource = this.pickSourceProvider.get('ABTesting');
                const pickId =
                    event.offerSource === OfferSource.V1
                        ? new V1PickId(event.id, parseInt(optionGroup.id), option.id)
                        : new V2OptionMarketPickId(
                              event.hybridFixtureData != null ? event.hybridFixtureData.fixtureId : event.id,
                              parseInt(optionGroup.id),
                              option.id,
                              option.priceId!,
                          );

                return {
                    pickId,
                    tracking: pickSource,
                    priceId: option.priceId,
                } as PickAddPayload;
            }
        }

        return null;
    }

    getRemovePickPayload(fixture: Fixture, optionId: number): PickId | null {
        const event = this.eventService.create(fixture);

        for (const optionGroup of event.optionGroups) {
            const option = optionGroup.options.find((current) => current.id === optionId);

            if (option) {
                return event.offerSource === OfferSource.V1
                    ? new V1PickId(event.id, parseInt(optionGroup.id), option.id)
                    : new V2OptionMarketPickId(event.id, parseInt(optionGroup.id), option.id, option.priceId!);
            }
        }

        return null;
    }
}
